import { Component, Input } from '@angular/core';
import { Company, CompanyEnum } from '../../models/company.model';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { PriceListTransferFee } from '../../models/pricelist-transfer.model';
import { CommonModule } from '@angular/common';
import { PositivelyTransferTableComponent } from './positively-transfer-table/positively-transfer-table.component';
import { AlpTransferTableComponent } from './alp-transfer-table/alp-transfer-table.component';
import { Currency } from '../../models/currency.model';

@Component({
  standalone: true,
  imports: [CommonModule, TableHeaderComponent, PositivelyTransferTableComponent, AlpTransferTableComponent],
  selector: 'lx-price-lists-portal-transfer-table',
  templateUrl: './transfer-table.component.html',
  styleUrls: ['./transfer-table.component.scss'],
})
export class TransferTableComponent {
  @Input() transfers: PriceListTransferFee | undefined;
  @Input() currency: Currency | undefined;
  @Input() company: Company = CompanyEnum.KIL;

  companyEnum = CompanyEnum;
}
